<script setup>
import { getStorage, setStorage } from "@/services/storage.js";
import { useStore } from 'vuex';
import { onMounted } from "vue";
  const store = useStore();
  onMounted(()=>{
    setStorage('auth',null);
    store.dispatch('setAuth', null);
    const savedLocale = getStorage('locale')
    const browserLocale = navigator.language.startsWith('he') ? 'he' : 'en'
    const lang  = store.getters.locale || savedLocale || browserLocale;
    window.location.href = process.env.VUE_APP_ISAVTA_URL+'/'+lang;
  })
</script>